// extracted by mini-css-extract-plugin
export default {"wrap":"_D-z"};